import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiCheckCircle, FiHelpCircle } = FiIcons;

const badgeBase =
  'inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-cond font-semibold uppercase tracking-wider border whitespace-nowrap';

export const StatusBadge = ({ status }) => {
  const isDiscontinued = status === 'Discontinued';
  return (
    <span
      className={`${badgeBase} ${
        isDiscontinued
          ? 'bg-red-50 text-red-800 border-red-200 dark:bg-red-500/10 dark:text-red-300 dark:border-red-500/30'
          : 'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/30'
      }`}
    >
      <SafeIcon icon={isDiscontinued ? FiAlertCircle : FiCheckCircle} className="w-3 h-3" />
      {status}
    </span>
  );
};

export const ConfidenceBadge = ({ confidence }) => {
  const styles = {
    Exact: 'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/30',
    Compatible: 'bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-500/10 dark:text-blue-300 dark:border-blue-500/30',
    Possible: 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/30',
  };

  const icons = {
    Exact: FiCheckCircle,
    Compatible: FiCheckCircle,
    Possible: FiHelpCircle,
  };

  return (
    <span className={`${badgeBase} ${styles[confidence] || styles.Possible}`}>
      <SafeIcon icon={icons[confidence] || FiHelpCircle} className="w-3 h-3" />
      {confidence} match
    </span>
  );
};
